import React, { useState } from "react";
import "../styles/OrganizingCommittee.css";

const OrganizingCommittee = () => {
  const [activeTab, setActiveTab] = useState("all");

  const renderOtherMembers = () => (
    <div className="other-members-container">
      {Object.values(committee.otherMembers).map((section, index) => (
        <div key={index} className="other-card">
          <h3 className="other-title">{section.title}</h3>

          <ul className="other-list">
            {section.members.map((name, i) => (
              <li key={i}>{name}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );

  const renderTPCChairs = () => (
    <div className="other-members-container">
      {Object.values(committee.tpcChairs).map((section, index) => (
        <div key={index} className="other-card">
          <h3 className="other-title">{section.title}</h3>

          <ul className="other-list">
            {section.members.map((name, i) => (
              <li key={i}>{name}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );

  const committee = {
    patronInChief: {
      name: "Prof. Indranil Manna",
      role: "Patron-in-Chief",
      img: "/Indranil.jpg",
      designation: "Vice Chancellor, BIT Mesra",
    },

    patrons: [
      {
        name: "Dr. Vijay Kumar Jha",
        role: "Patron",
        img: "/DrVijayKumarJha.jpg",
        designation: "Professor in-Charge, BIT Mesra (Lalpur Unit)",
      },
    ],

    chairs: [
      {
        name: "Dr. Abhijit Mustafi",
        role: "General Chair",
        img: "/abhijit.jpeg",
        designation: "Professor and Head, Computer Sc. and Engg.",
      },
    ],

    convenors: [
      {
        name: "Dr. Devesh Kumar Upadhyay",
        role: "Convenor",
        img: "/devesh.jpg",
        designation: "Computer Sc. and Engg.",
      },
    ],

    coconvenors: [
      {
        name: "Dr. Partha Sarathi Bishnu",
        role: "Co-Convenor",
        img: "/partha.jpeg",
        designation: "Computer Sc. and Engg.",
      },
      {
        name: "Dr. Nandan Banerji",
        role: "Co-Convenor",
        img: "/Nandan-Banerji.webp",
        designation: "Computer Sc. and Engg.",
      },
    ],

    speakers: [
      {
        name: "Chaitanya Bharath Somineni",
        role: "Invited Speaker",
        img: "/Speakers/chaitanya.jpg",
        designation: "Senior Cloud & Data Platform Architect",
        organization: "Toyota Motor Credit Corporation",
        expertise: "Data Engineering",
      },

      {
        name: "Lakshmi Narasimha Raju Mudunuri",
        role: "Invited Speaker",
        img: "/Speakers/Lakshmi.jpg",
        designation: "Department of Information Services",
        organization: "Valero Energy Corporation",
        expertise: "San Antonio, Texas, USA",
      },

      {
        name: "Leela Venkata Sai Rajesh Guntupalli",
        role: "Invited Speaker",
        img: "/Speakers/Leela.jpg",
        designation: "Lead Software Engineer",
        organization: "TD Bank, USA",
      },

      {
        name: "Veera Venkata Uday Kumar Jonnalagadda",
        role: "Invited Speaker",
        img: "/Speakers/Veera.jpg",
        designation: "Cybersecurity Manager",
        organization: "American Express Global Business Travel",
        expertise: "Texas, USA",
      },
      
    ],

    // Session Chairs and Session Coordinators
    sessionCommittee: {

      title: "Session Chairs",
      sections: 
      [
        {
          title: "Session Chairs",

          members: [
            {
              name: "Rajesh Mannam",
              role: "Session Chair",
              img: "/SchairScoordinators/rajesh.png",
              designation: "Technology Lead",
              organization: "Internal Quality Operations",
              expertise:
                "Gilead Sciences, San Mateo, California, United States",
            },

            {
              name: "Gopi Chand Vegineni",
              role: "Session Chair",
              img: "/SchairScoordinators/gopi.png",
              designation: "Sr. UI/UX Developer",
              organization: "Enrollment and Eligibility Team",
              expertise: "NexSolv Inc, USA",
            },

            {
              name: "Veera Venkata Uday Kumar Jonnalagadda",
              role: "Session Chair",
              img: "/Speakers/Veera.jpg",
              designation: "Cybersecurity Manager",
              organization: "American Express Global Business Travel",
              expertise: "Texas, USA",
            },

            {
              name: "Dr. Vandana Bhattacharjee",
              role: "Session Chair",
              img: "/SchairScoordinators/vandana.png",
              designation:
                "Professor, Department of Computer Science and Engineering",
              organization: "BIT Mesra, Ranchi",
            },
          ],
        },

        {
          title: "Session Coordinators",

          members: [
            {
              name: "Dr. Pranab Kumar",
              role: "Session Coordinator",
              img: "/SchairScoordinators/pranab.png",
              designation: "Professor",
              organization: "Department of Management Studies",
              expertise: "Birla Institute of Technology, Mesra",
            },

            {
              name: "Dr. G. P. Mishra",
              role: "Session Coordinator",
              img: "/SchairScoordinators/gpmishra.png",
              designation: "Professor",
              organization: "Department of Management Studies",
              expertise: "Birla Institute of Technology, Mesra",
            },

            {
              name: "Dr. Amrita Priyam",
              role: "Session Coordinator",
              img: "/SchairScoordinators/amrita.png",
              designation: "Associate Professor",
              organization:
                "Department of Computer Science and Engineering",
              expertise: "Birla Institute of Technology, Mesra",
            },
          ],
        },
      ],
    },

    members: [
      {
        name: "Dr. Debjani Mustafi",
        role: "Organizing Member",
        img: "/debjani.jpeg",
        designation: "Computer Sc. and Engg.",
      },
      {
        name: "Dr. Amrita Priyam",
        role: "Organizing Member",
        img: "/Amrita.jpeg",
        designation: "Associate Professor, Computer Sc. and Engg.",
      },
    ],

    tpcChairs: {
      international: {
        title: "International Technical Program Chairs (TPC)",
        members: [
          "Dr. Gustavo Javier Meschino, Universidad Nacional de Mar del Plata (UNMDP), Argentina",
          "Dr Manoj Kumar, University of Wollongong in Dubai, UAE",
          "Dr. Serhat Yilmaz, Kocaeli University, Kocaeli, Turkey",
          "Dr. Kasturi Dewi Varathan, Universiti Malaya, Kuala Lumpur, Malaysia",
          "Prof. Prasan Kumar Sahoo, Chang Gung University, Taiwan",
          "Dr. Bappaditya Dey, Interuniversity Microelectronics Centre, Leuven, Belgium",
          "Dr. Vimal Dwivedi, School of Computing, Engineering & Intelligent Systems, Ulster University, UK",
          "Mr. Mritunjay Tripathi, Associate Director of Technology, Mastek, Seattle, Washington, United States",
        ],
      },

      national: {
        title: "National Technical Program Chairs (TPC)",
        members: [
          "Prof. Supratim Biswas, BIT Mesra Ranchi",
          "Dr. Satyasai Jagannath Nanda, MNIT Jaipur",
          "Dr Niranjan Kumar Roy, KIIT, Bhuvneshwar",
          "Dr Tapan Kumar Das, VIT Vellore",
          "Dr Dinesh Singh, MNIT, Allahabad, Prayagraj",
          "Dr. Chandra Sekhar Panda, Sambalpur University",
          "Dr. Bhaskar Biswas, IIT(BHU), Varanasi",
          "Prof. Pramod Kumar Mishra, BHU, Varanasi",
          "Mr. Uday Shankar Mudigonda, Senior Director, AMD, Bengaluru, India",
        ],
      },
    },

    advisoryChairs: [
      {
        name: "Dr. Supratim Biswas",
        role: "Advisory Chair",
        noImage: true,
        designation: "Prof. & Ex-HOD, Dept. of CSE, BIT Mesra",
      },
      {
        name: "Dr. Vandana Bhattacharjee",
        role: "Advisory Chair",
        noImage: true,
        designation: "Prof., Dept. of Computer Sc. and Engg., BIT Mesra, Ranchi",
      },
      {
        name: "Dr. D.K. Malik",
        role: "Advisory Chair",
        noImage: true,
        designation: "Director, BIT Patna",
      },
      {
        name: "Dr. Niraj Kumar Singh",
        role: "Advisory Chair",
        noImage: true,
        designation: "BIT Mesra, Ranchi",
      },
      {
        name: "Dr. Subrajeet Mohapatra",
        role: "Advisory Chair",
        noImage: true,
        designation: "BIT Mesra, Ranchi",
      },
    ],

    // Student Committee Data
    studentCommittee: {
      title: "Student Committee",
      sections: [
        {
          title: "Website Committee",
          members: [
            {
              name: "Anurag Tiwari",
              designation: "BIT Lalpur",
              department: "MCA",
              role: "Website Committee",
              noImage: true,
            },
            {
              name: "Harshit Raj",
              designation: "BIT Lalpur",
              department: "MCA",
              role: "Website Committee",
              noImage: true,
            },
            {
              name: "Harshita Prasad",
              designation: "BIT Lalpur",
              department: "MCA",
              role: "Website Committee",
              noImage: true,
            },
          ],
        },
        {
          title: "Poster Committee",
          members: [
            {
              name: "Dhruv Maheshwari",
              designation: "BIT Lalpur",
              department: "MCA",
              role: "Poster Committee",
              noImage: true,
            },
            {
              name: "Aditya Nanda",
              designation: "BIT Lalpur",
              department: "MCA",
              role: "Poster Committee",
              noImage: true,
            },
            {
              name: "Soham Basak",
              designation: "BIT Lalpur",
              department: "MCA",
              role: "Poster Committee",
              noImage: true,
            },
            {
              name: "Shashikant Yadav",
              designation: "BIT Lalpur",
              department: "MCA",
              role: "Poster Committee",
              noImage: true,
            },
          ],
        },
      ],
    },

    otherMembers: {
      sponsorship: {
        title: "Sponsorship Committee",
        members: [
          "Dr. Prashant Kumar Singh, BIT Lalpur",
          "Dr. Siba Mitra, BIT Lalpur",
          "Dr. Ashutosh Mishra, BIT Lalpur",
        ],
      },

      prMedia: {
        title: "Public Relations and Media Committee",
        members: [
          "Dr. Abhaya Ranjan Srivastava, BIT Lalpur, Ranchi",
          "Mr. Rana Pratap Mishra, BIT Lalpur, Ranchi",
          "Dr. Siva Surya Narayana Chintapalli, BIT Lalpur, Ranchi",
          "Dr. Komal Naaz, BIT Mesra, Ranchi",
        ],
      },

      digitalMedia: {
        title: "Digital Media Committee",
        members: [
          "Dr. Umesh Prasad, BIT Lalpur",
          "Dr. Somnath Mukherjee, BIT Lalpur",
          "Dr. Syed Anis Haider, BIT Lalpur",
          "Dr. Ashutosh Mishra, BIT Lalpur",
          "Dr. Soumitro Chakravarty, BIT Lalpur",
          "Mrs. Vijaya Lakshmi Chintapalli, BIT Lalpur",
        ],
      },

      localArrangements: {
        title: "Local (Food and Lodging) Arrangements",
        members: [
          "Dr. S N Shadeo, BIT Lalpur",
          "Dr. Pradeep Munda, BIT Lalpur",
          "Mrs. Mini Kumari, BIT Lalpur",
          "Mr. Basudev Singh, BIT Lalpur",
        ],
      },

      socialTech: {
        title: "Social and Technical Events Committee",
        members: [
          "Dr. Ashutosh Mishra, BIT Lalpur",
          "Dr. Mili Dutta, BIT Lalpur",
          "Dr. Siba Mitra, BIT Lalpur",
          "Dr. Aparna Shukla, BIT Lalpur",
          "Mr. Shantunu Sinha, BIT Lalpur",
        ],
      },

      stage: {
        title: "Stage Committee",
        members: [
          "Dr. Amrita Sarkar, BIT Lalpur",
          "Dr. Mili Dutta, BIT Lalpur",
          "Ms. Anupma Sahai, BIT Lalpur",
        ],
      },

      hospitality: {
        title: "Hospitality and Reception Committee",
        members: [
          "Ms. Poonam Moral, BIT Lalpur",
          "Dr. Nandini Kumari, BIT Lalpur",
          "Dr. Sujata Banerjee, BIT Lalpur",
          "Dr. Arya S., BIT Lalpur",
        ],
      },

      technicalSupport: {
        title: "Technical Support Committee",
        members: [
          "Dr. Shalini Kumari, BIT Lalpur",
          "Dr. Vandana Kumari, BIT Lalpur",
          "Dr. Mayank Parashar, BIT Lalpur",
          "Mr. Subhasis Roy, BIT Lalpur",
        ],
      },

      certificate: {
        title: "Certificate Committee",
        members: [
          "Dr. Onima Tigga, BIT Lalpur",
          "Dr. Jaya Pal, BIT Lalpur",
          "Mrs. Mamata Pandey, BIT Lalpur",
        ],
      },

      publicity: {
        title: "Publicity and Website Committee",
        members: [
          "Mr. Subhasis Roy, BIT Lalpur",
          "Mr. Manoj Kumar, BIT Lalpur",
        ],
      },

      organizing: {
        title: "Organizing Committee",
        members: [
          "Dr. Sanjay Kumar, BIT Lalpur",
          "Dr. Amar Kumar, BIT Lalpur",
          "Dr. Nagendra Prasad Tiwary, BIT Lalpur",
          "Dr. Narendra Kumar Singh, BIT Lalpur",
          "Dr. Binod Kumar Sharma, BIT Lalpur",
          "Dr. Kuntal Mukherjee, BIT Lalpur",
          "Mr. Hareshwar Prasad, BIT Lalpur",
          "Mr. Khalid Ashraf, BIT Lalpur",
          "Dr. Mansi Gupta, BIT Lalpur",
          "Dr. Sushmita Palmal, BIT Lalpur",
          "Mr. Deepak Kumar Mishra, BIT Lalpur",
          "Dr. Mahua Banerjee, BIT Lalpur",
          "Dr. Arun Kumar Singh, BIT Lalpur",
          "Mr. Amitabh Chandan, BIT Lalpur",
          "Dr. Avinash Kumar Sinha, BIT Lalpur",
          "Dr. Jaleshwar Bhagat, BIT Lalpur",
          "Dr. Satrajeet Choudhury, BIT Lalpur",
          "Dr. Tanmoy Kumar Banerjee, BIT Lalpur",
        ],
      },

      sessionCoordinators: {
        title: "Session Co-ordination Committee",
        members: [
          "Dr. Ganesh Prasad Mishra, BIT Lalpur",
          "Dr. Pranab Kumar, BIT Lalpur",
          "Dr. Srabani Mukhopadhyaya, BIT Lalpur",
          "Dr. Siba Mitra, BIT Lalpur",
          "Dr. Aparna Shukla, BIT Lalpur",
          "Ms. Anupma Sahai, BIT Lalpur",
        ],
      },
    },
  };

  const CommitteeCard = ({ member }) => (
    <div className="committee-card">
      <div className="card-header">
        {!member.noImage && (
          <div className="card-image">
            <img src={member.img} alt={member.name} />
          </div>
        )}
        <div className="commit-info">
          <h3>{member.name}</h3>
          <span className="role-badge">{member.role}</span>
        </div>
      </div>

      <div className="card-body">
        <p className="designation">{member.designation}</p>

        {member.organization && <p>{member.organization}</p>}

        {member.expertise && <p>{member.expertise}</p>}

        {member.contact && (
          <p className="contact">
            <strong>Mobile:</strong> {member.contact}
          </p>
        )}

        {member.email && (
          <p className="contact">
            <strong>Email:</strong>{" "}
            <a href={`mailto:${member.email}`}>{member.email}</a>
          </p>
        )}
      </div>
    </div>
  );

  const renderSection = (title, members) => (
    <>
      <h3 className="category-title">{title}</h3>
      <div className="committee-grid">
        {members.map((member, index) => (
          <CommitteeCard key={index} member={member} />
        ))}
      </div>
    </>
  );

  return (
    <section id="committee" className="organizing-committee">
      <div className="commit-container">
        <h2 className="section-title">Organizing Committee</h2>
        <p className="section-subtitle">
          International Conference on Emerging Trends and Technologies in
          Applications of Computer Science
        </p>
        {/* Navigation Tabs */}
        <div className="committee-nav">
          <button
            className={`tab-btn ${activeTab === "all" ? "active" : ""}`}
            onClick={() => setActiveTab("all")}
          >
            All
          </button>

          <button
            className={`tab-btn ${activeTab === "patrons" ? "active" : ""}`}
            onClick={() => setActiveTab("patrons")}
          >
            Patrons & Chair
          </button>

          <button
            className={`tab-btn ${activeTab === "convenor" ? "active" : ""}`}
            onClick={() => setActiveTab("convenor")}
          >
            Convenor
          </button>

          <button
            className={`tab-btn ${activeTab === "coconvenors" ? "active" : ""}`}
            onClick={() => setActiveTab("coconvenors")}
          >
            Co-Convenors
          </button>

          <button
            className={`tab-btn ${activeTab === "speakers" ? "active" : ""}`}
            onClick={() => setActiveTab("speakers")}
          >
            Invited Speakers
          </button>

          <button
            className={`tab-btn ${activeTab === "sessionCommittee" ? "active" : ""}`}
            onClick={() => setActiveTab("sessionCommittee")}
          >
            Session Chairs
          </button>

          <button
            className={`tab-btn ${activeTab === "members" ? "active" : ""}`}
            onClick={() => setActiveTab("members")}
          >
            Members
          </button>

          {/* TPC Chairs */}
          <button
            className={`tab-btn ${activeTab === "tpcChairs" ? "active" : ""}`}
            onClick={() => setActiveTab("tpcChairs")}
          >
            TPC Chairs
          </button>

          <button
            className={`tab-btn ${
              activeTab === "advisoryChairs" ? "active" : ""
            }`}
            onClick={() => setActiveTab("advisoryChairs")}
          >
            Advisory Chairs
          </button>

          {/* <button
            className={`tab-btn ${
              activeTab === "sessionCoordinators" ? "active" : ""
            }`}
            onClick={() => setActiveTab("sessionCoordinators")}
          >
            Session Co-ordination Committee
          </button> */}

          <button
            className={`tab-btn ${
              activeTab === "studentCommittee" ? "active" : ""
            }`}
            onClick={() => setActiveTab("studentCommittee")}
          >
            Student Committee
          </button>

          <button
            className={`tab-btn ${activeTab === "otherMembers" ? "active" : ""}`}
            onClick={() => setActiveTab("otherMembers")}
          >
            Other Members
          </button>
        </div>
        {activeTab === "all" && (
          <>
            {renderSection("Patron-in-Chief", [committee.patronInChief])}

            {renderSection("Patrons & General Chair", [
              ...committee.patrons,
              ...committee.chairs,
            ])}

            {renderSection("Convenor", committee.convenors)}

            {renderSection("Co-Convenors", committee.coconvenors)}

            {renderSection("Organizing Members", committee.members)}
            {renderSection("Invited Speakers", committee.speakers)}
            {/* Session Committee Sections */}
                <h3 className="category-title">
                  {committee.sessionCommittee.title}
                </h3>

                {committee.sessionCommittee.sections.map(
                  (section, sectionIndex) => (
                    <div key={sectionIndex}>
                      <h4
                        className="subcategory-title"
                        style={{
                          marginTop: "2rem",
                          marginBottom: "1rem",
                          color: "#2563eb",
                          fontSize: "1.3rem",
                          fontWeight: "600",
                          textAlign: "center",
                        }}
                      >
                        {section.title}
                      </h4>
                      
                      <div className="committee-grid">
                        {section.members.map((member, memberIndex) => (
                          <CommitteeCard
                            key={memberIndex}
                            member={member}
                          />
                        ))}
                      </div>
                    </div>
                  )
                )}
            {renderSection("Advisory Chairs", committee.advisoryChairs)}

            {/* Student Committee Sections */}
            <h3 className="category-title">
              {committee.studentCommittee.title}
            </h3>

            {committee.studentCommittee.sections.map(
              (section, sectionIndex) => (
                <div key={sectionIndex}>
                  <h4
                    className="subcategory-title"
                    style={{
                      marginTop: "2rem",
                      marginBottom: "1rem",
                      color: "#2563eb",
                      fontSize: "1.3rem",
                      fontWeight: "600",
                      textAlign: "center",
                    }}
                  >
                    {section.title}
                  </h4>

                  <div className="committee-grid">
                    {section.members.map((member, memberIndex) => (
                      <CommitteeCard
                        key={memberIndex}
                        member={{
                          ...member,
                          designation: `${member.designation} • ${member.department}`,
                        }}
                      />
                    ))}
                  </div>
                </div>
              ),
            )}
          </>
        )}

        {activeTab === "patrons" &&
          renderSection("Patrons & General Chair", [
            ...committee.patrons,
            ...committee.chairs,
          ])}
        {activeTab === "convenor" &&
          renderSection("Convenor", committee.convenors)}
        {activeTab === "coconvenors" &&
          renderSection("Co-Convenors", committee.coconvenors)}
        {activeTab === "members" &&
          renderSection("Organizing Members", committee.members)}
        {activeTab === "speakers" &&
          renderSection("Invited Speakers", committee.speakers)}
        {activeTab === "sessionCommittee" && (
          <>
            <h3 className="category-title">
              {committee.sessionCommittee.title}
            </h3>

            {committee.sessionCommittee.sections.map(
              (section, sectionIndex) => (
                <div key={sectionIndex}>
                  <h4
                    className="subcategory-title"
                    style={{
                      marginTop: "2rem",
                      marginBottom: "1rem",
                      color: "#2563eb",
                      fontSize: "1.3rem",
                      fontWeight: "600",
                      textAlign: "center",
                    }}
                  >
                    {section.title}
                  </h4>
                  
                  <div className="committee-grid">
                    {section.members.map((member, memberIndex) => (
                      <CommitteeCard
                        key={memberIndex}
                        member={member}
                      />
                    ))}
                  </div>
                </div>
              )
            )}
          </>
        )}
        {activeTab === "tpcChairs" && renderTPCChairs()}
        {activeTab === "advisoryChairs" &&
          renderSection("Advisory Chairs", committee.advisoryChairs)}
        {activeTab === "studentCommittee" && (
          <>
            <h3 className="category-title">
              {committee.studentCommittee.title}
            </h3>

            {committee.studentCommittee.sections.map(
              (section, sectionIndex) => (
                <div key={sectionIndex}>
                  <h4
                    className="subcategory-title"
                    style={{
                      marginTop: "2rem",
                      marginBottom: "1rem",
                      color: "#2563eb",
                      fontSize: "1.3rem",
                      fontWeight: "600",
                      textAlign: "center",
                    }}
                  >
                    {section.title}
                  </h4>

                  <div className="committee-grid">
                    {section.members.map((member, memberIndex) => (
                      <CommitteeCard
                        key={memberIndex}
                        member={{
                          ...member,
                          designation: `${member.designation} • ${member.department}`,
                        }}
                      />
                    ))}
                  </div>
                </div>
              ),
            )}
          </>
        )}

        {activeTab === "otherMembers" && renderOtherMembers()}
        <div className="committee-intro">
          <h3>Welcome to Our Organizing Committee</h3>
          <p>
            We proudly present our Organizing Committee Members, whose scholarly
            contributions and leadership form the backbone of this conference.
            Their dedication ensures a high standard of technical quality,
            innovation, and academic integrity.
          </p>
        </div>
      </div>
    </section>
  );
};

export default OrganizingCommittee;
